import {
  CREATE_SKU_REQUEST,
  UPDATE_SKU_REQUEST,
  PROMISE_FULFILLED,
  PROMISE_REJECTED,
  PROMISE_PENDING
} from '../constants/';
import error from '../utils/error';

const initialState = {
  details: {
    data: {
      id: 0
    },
    error: null,
    isSubmit: false,
  }
}

const reducer = (state = initialState, action) => {
  switch(action.type){
    case `${CREATE_SKU_REQUEST}${PROMISE_PENDING}`:
    case `${UPDATE_SKU_REQUEST}${PROMISE_PENDING}`: {
      return { ...state, details: { ...state.details, isSubmit: true } }
    }
    case `${CREATE_SKU_REQUEST}${PROMISE_REJECTED}`:
    case `${UPDATE_SKU_REQUEST}${PROMISE_REJECTED}`: {
      return { ...state, details: { ...state.details, isSubmit: false, ...error(action.payload) } }
    }
    case `${CREATE_SKU_REQUEST}${PROMISE_FULFILLED}`:
    case `${UPDATE_SKU_REQUEST}${PROMISE_FULFILLED}`: {
      const { data, ...payload } = action.payload;
      return { ...state, details: { ...state.details, isSubmit: false, error: null, data, ...payload } }
    }
    default: return {...state}
  }
}

export default reducer;